import { Router } from "@angular/router";
import { Injectable } from '@angular/core';
import { catchError } from "rxjs/operators";
import { Observable, throwError } from "rxjs";
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";

import { LoginService } from "../login/login.service";
import { NotificationType } from "./errors/model/notification-type.model";
import { NotificationService } from "./errors/services/notification.service";

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor(private router: Router,
              private loginService: LoginService,
              private notificationService: NotificationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const token = localStorage.getItem('access_token');
    const access_token = localStorage.getItem('access_token');

    /**
     * @description intercept the request and capture any error. So case the connection fail
     * try again 5 seconds later.
     * @param request information about the request.
     * @param next send a configuration to request handler.
     */
    if (!request.url.includes('http://hom.id.ms.gov.br/auth/realms/ms/protocol/openid-connect/token')
        && !request.url.includes('viacep') && !request.url.includes('http://www.mocky.io/')) {
      if (access_token !== null && access_token !== undefined) {
        request = this.addAuthenticationToken(request, access_token);
      }
    }
    return next.handle(request).pipe(catchError(error => {
      if(error instanceof HttpErrorResponse && error.status === 401) {
        this.loginService.logout();
        this.notificationService.sendNotification({
          title: 'Sessão Expirada',
          message: 'Sua sessão expirou! Para continuar utilizando o sistema tente novamente.',
          type: NotificationType.WARNING,
          time: 5000
        });

        this.router.navigate(['']);
      }
      return throwError(error);
    }));
  }

  addAuthenticationToken(request: HttpRequest<any>, token: string): HttpRequest<any> {
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`,
        'Access-Control-Allow-Origin': '*',
        'Cache-Control': 'no-cache',
        'Pragma': 'no-cache',
        'Expires': '0'
      }
    });
  }
}
